import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ProgressBar from '../../ProgressBar';
import { FlexFlow } from '../../styles/Layout';
import {
  TimerBlockWrapper,
  TimerBlockTitle,
  TimerBlockAmount,
  TimerClock,
  TimerClockValue,
  TimerClockTitle,
} from './styles';

const TimerBlock = ({ toDate, inStock }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hrs: 0,
    min: 0,
    sec: 0,
  });

  const updateTime = () => {
    const today = moment();
    const date = moment(toDate);

    const days = date.diff(today, 'days');
    const hrs = date.diff(today, 'hours');
    const min = date.diff(today, 'minutes');
    const sec = date.diff(today, 'seconds');

    setTimeLeft({
      days,
      hrs: hrs % 24,
      min: min % 60,
      sec: sec % 60,
    });
  };

  setTimeout(() => updateTime(), 1000);

  const addZero = (num) => (num < 10 ? `0${num}` : num);

  const {
    days, hrs, min, sec,
  } = timeLeft;

  return (
    <TimerBlockWrapper>
      <TimerBlockTitle>
        Hurry! Only
        <TimerBlockAmount>{inStock}</TimerBlockAmount>
        left in stock
      </TimerBlockTitle>
      <ProgressBar value={70} />
      <FlexFlow justify="space-around">
        <TimerClock>
          <TimerClockValue>{days}</TimerClockValue>
          <TimerClockTitle>Days</TimerClockTitle>
        </TimerClock>
        <TimerClock>
          <TimerClockValue>{addZero(hrs)}</TimerClockValue>
          <TimerClockTitle>Hours</TimerClockTitle>
        </TimerClock>
        <TimerClock>
          <TimerClockValue>{addZero(min)}</TimerClockValue>
          <TimerClockTitle>Minutes</TimerClockTitle>
        </TimerClock>
        <TimerClock>
          <TimerClockValue>{addZero(sec)}</TimerClockValue>
          <TimerClockTitle>Seconds</TimerClockTitle>
        </TimerClock>
      </FlexFlow>
    </TimerBlockWrapper>
  );
};

TimerBlock.defaultProps = {
  inStock: 0,
};

TimerBlock.propTypes = {
  toDate: PropTypes.string.isRequired,
  inStock: PropTypes.number,
};

export default TimerBlock;
